module.exports = __webpack_public_path__ + "img/qr_1.bbae2824.png";